import {
  actionTypes,
  getTablesConfigurationManagementDataFailureAction,
  getTablesConfigurationManagementDataSuccessAction,
  updateTablesConfigurationFailureAction,
  updateTablesConfigurationSuccessAction,
} from "./actions";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  fetchTablesConfigurationManagementData,
  fetchUpdateTablesConfiguration,
} from "./services";

const fetchTablesConfigurationManagementDataEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_TABLES_CONFIGURATION_MANAGEMENT_DATA),
    mergeMap((action: any) =>
      fetchTablesConfigurationManagementData(action.payload).pipe(
        map((response: any) =>
          getTablesConfigurationManagementDataSuccessAction(response)
        ),
        catchError((error: any) =>
          of(getTablesConfigurationManagementDataFailureAction(error))
        )
      )
    )
  );

const updateTablesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_TABLES_CONFIGURATION),
    mergeMap((action: any) =>
      fetchUpdateTablesConfiguration(action.payload).pipe(
        map((response: any) =>
          updateTablesConfigurationSuccessAction(response)
        ),
        catchError((error: any) =>
          of(updateTablesConfigurationFailureAction(error))
        )
      )
    )
  );

export default [
  fetchTablesConfigurationManagementDataEpic,
  updateTablesConfigurationEpic,
];
